<section class="section-div">
  <div class="content-details">
    <mat-tab-group #tabGroup (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Workplan">
        <div class="p-4">
          <app-workplan-list
            #workplanComponent
            [parent]="this"
          ></app-workplan-list>
        </div>
      </mat-tab>
      <mat-tab label="Budget">
        <div class="p-4">
          <app-budget #budgetComponent [parent]="this"></app-budget>
        </div>
      </mat-tab>
      <mat-tab label="Breakup of Budget">
        <div class="p-4">
          <app-breakup-budget
            #breakupBudgetComponent
            [parent]="this"
          ></app-breakup-budget>
        </div>
      </mat-tab>
      <mat-tab label="Financing">
        <div class="p-4">
          <app-financing #FinancingComponent [parent]="this"></app-financing>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
